<template>
  <a-space
    size="small"
    class="space-flex"
  >
    <UserAvatar
      :avatar-url="user.avatarUrl"
      :size="avatarSize"
    />
    <div :style="{ fontSize: textSize + 'px' }">
      {{ user.nickname || user.name }}
      <span v-if="completeDepartmentName">
        【{{ completeDepartmentName }}】
      </span>
    </div>
  </a-space>
</template>

<script>
import { computed } from 'vue'

import UserAvatar from '@/components/UserAvatar'

export default {
  name: 'AlignUser',
  components: {
    UserAvatar
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    avatarSize: {
      type: Number,
      default: 20
    },
    textSize: {
      type: Number,
      default: 14
    }
  },
  setup (props) {
    return {
      completeDepartmentName: computed(() =>
        props.user.mainDepartmentId && (props.user.mainDepartmentId.displayName || props.user.mainDepartmentId.completeName)
      )
    }
  }
}
</script>
